import { render } from "./el-table.vue?vue&type=template&id=712f6494"
import script from "./el-table.vue?vue&type=script&lang=ts"
export * from "./el-table.vue?vue&type=script&lang=ts"

import "./el-table.vue?vue&type=style&index=0&id=712f6494&lang=less"
script.render = render

export default script